module.exports = __webpack_public_path__ + "img/carteirinhaCaoFrente_3.7ead6c7b.jpeg";